export default __webpack_public_path__ + "static/media/logo_trenitalia.f5b9947c.svg";